import { cn } from '../../../utils/cn';
import logoLight from '../../../assets/logo-light.svg';
import logoDark from '../../../assets/logo-dark.svg';
import logoIcon from '../../../assets/logo-icon.svg';

export function Logo({ tone = 'dark', compact, className }: { tone?: 'dark' | 'light'; compact?: boolean; className?: string }) {
  if (compact) {
    return (
      <span className={cn('inline-flex items-center justify-center', className)}>
        <img src={logoIcon} alt="Electroz" className="h-9 w-9" />
      </span>
    );
  }
  return (
    <span className={cn('inline-flex items-center', className)}>
      <img
        src={tone === 'dark' ? logoDark : logoLight}
        alt="Electroz"
        className="h-9 w-auto"
      />
    </span>
  );
}

export default Logo;
